import React from 'react'
import Svg from './Svg'
export const SvgXCircle = React.forwardRef(({ size, ...props }, svgRef) => (
  <Svg viewBox="0 0 24 24" height={size} width={size} fill="currentColor" ref={svgRef} {...props}>
    <path d="M12 0C5.4 0 0 5.4 0 12s5.4 12 12 12 12-5.4 12-12S18.6 0 12 0zm5.2 14.7c.7.7.7 1.8 0 2.5s-1.8.7-2.5 0L12 14.5l-2.7 2.7c-.7.7-1.8.7-2.5 0s-.7-1.8 0-2.5L9.5 12 6.8 9.3c-.7-.7-.7-1.8 0-2.5s1.8-.7 2.5 0L12 9.5l2.7-2.7c.7-.7 1.8-.7 2.5 0s.7 1.8 0 2.5L14.5 12l2.7 2.7z" />
  </Svg>
))
SvgXCircle.isIcon = true
export default SvgXCircle
